import moment from 'moment';

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

class CurrentStatus extends Component {
  remainingHoursText = (remainingHours, isTrial) => {
    const cycleText = isTrial ? 'trial period' : 'current cycle';
    if (remainingHours) {
      const hourNoun = remainingHours === 1 ? 'hour' : 'hours';
      return `${remainingHours} ${hourNoun} remaining in ${cycleText}`;
    }
    return `No hours remaining in ${cycleText}`;
  };

  render() {
    const { minutesLeft, stripePlan } = this.props.user;
    if (!minutesLeft) return null;
    const currentCycleEnd = moment(minutesLeft.current.end)
      .utc()
      .format('MMMM DD, YYYY');
    const remainingHours = minutesLeft.current.minutes / 60;

    return (
      <div id="current-status" className="current-status card mb-3 p-4 p-md-5">
        <Fragment>
          <h5>
            {minutesLeft.isTrialPeriod ? 'Trial Period' : 'Current Cycle'}
          </h5>
          <p>{`Valid through ${currentCycleEnd}`}</p>
        </Fragment>
        <h5>{stripePlan.name}</h5>
        <p className="text-inactive mb-0">
          {this.remainingHoursText(remainingHours, minutesLeft.isTrialPeriod)}
        </p>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.profile,
  };
}

export default connect(mapStateToProps, {})(CurrentStatus);



// WEBPACK FOOTER //
// ./src/pages/student/Profile/routes/LowerTierPlan/CurrentStatus/index.js